// extracted by mini-css-extract-plugin
module.exports = {"u-hide-tablet":"_2XIZ_x_x-HLc_mTi-kufyS","u-show-tablet":"_2EqjB6Hdim1r1JioYCu-Ya","u-show-tablet-inline":"_13IipMHF0S3boQ4jfji7D1","doughnut-chart":"_37pH4QK0N1SjFD-KzlNEsV"};